import React from 'react'
import TouchBallLoading from 'react-loadingg/lib/TouchBallLoading'
import Style from './LoadingComponet.module.css'
const LoadingComponet = () => {
    return (
        <div className={Style.ComponentHolder}>
            <TouchBallLoading color={'#C20C64'} style={{marginBottom:"0.2rem"}}/>

            <p>لطفا صبر کنید...</p>
        </div>
    )
}

export default LoadingComponet
